import React, { useState, useEffect, useRef } from "react";
import { db } from "./firebase";
import "./EliminationDraw.css";
import GolferDrawn from "./GolferDrawn";
import { useStateValue } from "./StateProvider";

function EliminationDraw() {
  const [golfers, setGolfers] = useState([]);
  const [last, setLast] = useState([]);
  const [date, setDate] = useState([]);
  const eventDate = "20210812";

  useEffect(() => {
    // Create query to fetch golfers
    db.collection("events")
      .doc(eventDate)
      .collection("scores")
      .onSnapshot((snapshot) => {
        setGolfers(snapshot.docs.map((doc) => doc.data()));
      });

    const unsub = db
      .collection("events")
      .doc(eventDate)
      .collection("scores")
      .onSnapshot(() => {});

    return () => {
      // Stop listening for change******************************************************
      unsub();
    };
  }, []);

  useEffect(() => {
    findLast();
  }, [golfers]);

  const findLast = () => {
    const drawn = golfers.filter((g) => g.isDrawn === true);
    // console.log("drawn", drawn);
    sort(drawn);
    setLast(drawn[drawn.length - 1]);
    // console.log("last", drawn[drawn.length - 1]);
  };

  const sort = (array) =>
    array.sort((a, b) => {
      return a.isDrawnNum - b.isDrawnNum;
    });

  return (
    <div>
      {last && (
        <div className="lastPickedContainer">
          <div className="lastPickedTitle">LAST PICKED</div>
          <div className="lastPicked">
            <div>{last.name}</div>
            <div>{last.isDrawnNum}</div>
          </div>
        </div>
      )}

      <div>
        {golfers.map((player) => (
          <GolferDrawn key={player.idgame} golfer={player} />
        ))}
      </div>
    </div>
  );
}

export default EliminationDraw;
